import React, { useState } from "react";
import "../myschedule.scss";
import closeIcon from "../../../../assets/close.svg";
import {
  DELAY_MARKING_RADIO_BTN,
  MY_VACATIONS,
  MY_VACATIONS_RADIO_BTN,
} from "../Constants";

const ViewLogsContainer = ({
  addClass,
  setAddClass,
  drawerTitle,
  children,
  logType,
  handleRadioBtn,
  selectedRadioBtn,
}) => {
  return (
    <div>
      <div
        className={`w-100 ${
          addClass === "" ? "btm-drawer-default" : addClass
        } `}
      >
        <div className="p-3">
          <div
            className="my-2"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="d-flex align-items-center">
              <div className="display-title">
                <strong>{drawerTitle}</strong>
              </div>
              {logType === MY_VACATIONS && (
                <div className="d-flex px-4">
                  <div
                    // className="form-check form-check-inline"
                    style={{
                      width: "130px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <input
                      // className="form-check-input gender-input"
                      type="radio"
                      value={MY_VACATIONS_RADIO_BTN}
                      id="My Vacations"
                      name="log"
                      checked={selectedRadioBtn === MY_VACATIONS_RADIO_BTN}
                      onChange={handleRadioBtn}
                    />
                    <label htmlFor="My Vacations" className="mb-0 px-2">
                      <span>My Vacations</span>
                    </label>
                  </div>
                  <div
                    // className="form-check form-check-inline"
                    style={{
                      width: "130px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <input
                      // className="form-check-input gender-input"
                      type="radio"
                      value={DELAY_MARKING_RADIO_BTN}
                      id="Delay Marking"
                      name="log"
                      checked={selectedRadioBtn === DELAY_MARKING_RADIO_BTN}
                      onChange={handleRadioBtn}
                    />
                    <label htmlFor="Delay Marking" className="mb-0 px-2">
                      <span>Delay Marking</span>
                    </label>
                  </div>
                </div>
              )}
            </div>
            <div className="close-btn" onClick={() => setAddClass("")}>
              <span>
                Close <img src={closeIcon} alt="close" />
              </span>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ViewLogsContainer;
